// @ts-expect-error https://vite.dev/config/build-options.html#build-modulepreload
import "vite/modulepreload-polyfill";
window.global ||= window;
// TODO: Remove polyfills
import "./polyfill/polyfills.js";
import "./vendor/vendor.js";
import "../scss/main.scss"; 
import { initializeOdp } from "./integrations/odp/main";

import { mainModules } from "./pages/main/config";
import { createXylemApp } from "./createXylemApp";
import { initializeFontAwesome } from "./core/fontawesome";

initializeFontAwesome();
await initializeOdp();
await createXylemApp({ modules: mainModules });
